import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SERVICE_STATUS_PROVIDER, ServiceStatusProvider } from './service-status.provider';

interface ServiceUnavailableConfig {
  userJourney?: {
    serviceUnavailablePageTitle?: string;
    serviceUnavailablePageGuidanceText?: string;
  };
}

@Component({
  selector: 'lib-service-unavailable',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './service-unavailable.component.html',
  styleUrl: './service-unavailable.component.scss',
})
export class ServiceUnavailableComponent implements OnInit {
  serviceUnavailableContent = { title: '', message: '' };
  configChecked = false;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(SERVICE_STATUS_PROVIDER) private statusProvider: ServiceStatusProvider,
  ) {}

  ngOnInit(): void {
    // Clear any leftover spinner from the previous page, then show our own.
    this.spinner.hide();
    this.spinner.show();

    this.loadContent();
    this.checkForRecovery();
  }

  private async loadContent(): Promise<void> {
    try {
      const config = (await this.statusProvider.getConfigByAppConfig()) as ServiceUnavailableConfig | undefined;
      this.serviceUnavailableContent.title = config?.userJourney?.serviceUnavailablePageTitle ?? '';
      this.serviceUnavailableContent.message = config?.userJourney?.serviceUnavailablePageGuidanceText ?? '';
    } catch (error) {
      console.error('Error refreshing config on service unavailable page:', error);
    } finally {
      this.spinner.hide();
      this.configChecked = true;
    }
  }

  private async checkForRecovery(): Promise<void> {
    const recoveryRoute = this.route.snapshot.data['recoveryRoute'] ?? '/login';
    try {
      const result = await this.statusProvider.getServiceStatus('JRNI');
      if (result?.status === true) {
        this.router.navigate([recoveryRoute]);
      }
    } catch (error) {
      console.error('Error fetching service status on service unavailable page:', error);
    }
  }
}
